const aiPromptSettingsSwedish = {
  header: {
    title: "AI-inställningar",
    description: "Anpassa hur AI:n genererar dina LinkedIn-inlägg"
  },
  sections: {
    profiles: {
      title: "LinkedIn-profiler",
      description: "Lägg till länkar till LinkedIn-profiler vars stil du vill efterlikna."
    },
    products: {
      title: "Produkter",
      description: "Lägg till dina produkter eller tjänster som AI:n kan referera till i inläggen."
    },
    leadMagnets: {
      title: "Lead Magnets",
      description: "Lägg till gratisresurser eller lead magnets som du vill erbjuda i dina inlägg."
    },
    examples: {
      title: "Exempel på Bra Inlägg",
      description: "Lägg till exempel på framgångsrika LinkedIn-inlägg som AI:n kan lära sig från."
    },
    callToAction: {
      title: "Call-to-Action-inställningar",
      description: "Kontrollera hur ofta dina inlägg ska innehålla en call-to-action."
    },
    emoji: {
      title: "Emoji-inställningar",
      description: "Kontrollera hur många emojis dina inlägg ska innehålla."
    },
    language: {
      title: "Inläggsspråk",
      description: "Välj vilket språk dina inlägg ska genereras på. Detta påverkar endast språket i inläggen, inte användargränssnittets språk."
    }
  },
  buttons: {
    add: {
      profile: "Lägg till profil",
      product: "Lägg till produkt",
      leadMagnet: "Lägg till Lead Magnet",
      example: "Lägg till exempel"
    }
  },
  modal: {
    titles: {
      addProfile: "Lägg till LinkedIn-profil",
      editProfile: "Redigera LinkedIn-profil",
      addProduct: "Lägg till produkt",
      editProduct: "Redigera produkt",
      addLeadMagnet: "Lägg till Lead Magnet",
      editLeadMagnet: "Redigera Lead Magnet",
      addExample: "Lägg till exempel på bra inlägg",
      editExample: "Redigera exempel på bra inlägg"
    },
    placeholders: {
      profile: "LinkedIn-profillänk (t.ex. https://www.linkedin.com/in/johndoe)",
      productName: "Produktnamn",
      productDescription: "Beskrivning av produkten och dess funktioner",
      leadMagnetName: "Lead magnet-namn",
      leadMagnetDescription: "Beskrivning av resursen och dess värde",
      example: "Infoga ett exempel på ett bra LinkedIn-inlägg"
    },
    buttons: {
      cancel: "Avbryt",
      add: "Lägg till",
      save: "Spara ändringar"
    }
  },
  ctaFrequency: {
    always: "Alltid",
    every2: "Vartannat inlägg",
    every3: "Vart tredje inlägg",
    every4: "Vart fjärde inlägg",
    never: "Aldrig",
    withCta: "Med CTA",
    withoutCta: "Utan CTA"
  },
  emojiFrequency: {
    none: "Inga",
    few: "Några få",
    medium: "Måttligt",
    many: "Många",
    examples: {
      none: "Inlägg utan emojis.",
      few: "Få emojis 👍",
      medium: "Måttligt med emojis 👋 för att lyfta fram viktiga poänger ✅",
      many: "Många emojis 🚀 för energisk text 🔥 som fångar ögat 👀 och skapar engagemang 💪"
    }
  },
  preferredEmojis: {
    label: "Föredragna emojis:",
    placeholder: "Ange dina föredragna emojis (t.ex.: 🚀 ✨ 💪 🔥 👍)",
    description: "AI:n kommer att prioritera dessa emojis i dina inlägg, men kommer fortfarande att använda andra för att säkerställa variation."
  },
  postLanguage: {
    examples: {
      da: "Dette er et eksempel på et opslag på dansk. AI'en vil generere indhold på dette sprog.",
      en: "This is an example of a post in English. The AI will generate content in this language.",
      no: "Dette er et eksempel på et innlegg på norsk. AI-en vil generere innhold på dette språket.",
      sv: "Detta är ett exempel på ett inlägg på svenska. AI:n kommer att generera innehåll på detta språk."
    },
    previewHeader: "Exempelinlägg"
  },
  save: {
    success: "Inställningar sparade!",
    error: "Fel vid sparande. Försök igen."
  },
  customerBanner: "Du redigerar AI-inställningar för {customerName}",
  about: {
    title: "Om dig själv",
    label: "Berätta för AI:n om din bakgrund och expertis",
    placeholder: "Exempel: Jag är en digital marknadsföringskonsult med 8 års erfarenhet inom e-handel. Jag specialiserar mig på SEO, Google Ads och konverteringsoptimering. Jag hjälper små och medelstora företag att öka sin online-försäljning...",
    helpText: "Detta fält ger AI:n värdefull kontext om din professionella bakgrund, bransch och expertis. Informationen används för att skapa mer relevanta och autentiska inlägg, men nämns inte direkt om det inte är särskilt relevant."
  },
  customPrompt: {
    title: "Anpassad System Prompt",
    description: "Lägg till dina egna instruktioner till AI:n. Detta är endast för avancerade användare som vill justera systemprompten.",
    label: "Extra instruktioner till AI:n (valfritt)",
    placeholder: "Exempel: 'Skriv alltid i en mycket personlig och humoristisk ton' eller 'Fokusera på att ställa frågor till läsarna i slutet av varje inlägg'",
    warning: "Varning: Detta fält är för avancerade användare. Felaktiga instruktioner kan påverka kvaliteten på dina inlägg negativt. Lämna fältet tomt om du är osäker."
  }
};

export default aiPromptSettingsSwedish; 